var _module_exports = "<div ui-view class=\"fade-in-right-big smooth signin-wrapper\"></div>";;
var path = '/app/vendor/ec-fe-bo-template/dist/views/base/access.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/ec-fe-bo-template/dist/views/base/access.html
// module id = 918
// module chunks = 0